import React from 'react';
import { Box } from '@mui/material';
import LanguageSwitcher from './LanguageSwitcher';
import SalovareLoader from './SalovareLoader';
import { BRAND } from '../../theme/brandTokens';
import { brandBackdropSx } from '../../theme/brandSurfaces';

const backgroundStyle = {
  minHeight: '100vh',
  width: '100vw',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  ...brandBackdropSx,
  position: 'fixed',
  top: 0,
  left: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
};

/**
 * PageLoadingSpinner - Full-page branded loader for auth and bootstrap screens.
 */
const PageLoadingSpinner = () => (
  <Box sx={backgroundStyle}>
    <Box sx={{ position: 'absolute', top: 24, right: 24 }}>
      <LanguageSwitcher />
    </Box>
    <SalovareLoader size="large" showMessage center messageSx={{ color: BRAND.onPrimaryMuted }} />
  </Box>
);

export default PageLoadingSpinner;

